export enum ModalActionType {
  CANCEL,
  PRIMARY,
}
export default ModalActionType;
